<template>
  <div class="channelsContainer">
    <div class="firstChannelContainer">
      <ChannelWorkspace class="firstChannel" v-if="getFirstChannel" :channel="getFirstChannel" :delete-action="false"
                        :selectable="true"/>
    </div>
    <b-dropdown v-if="weet.channels.length>1" class="plusDropDown" position="is-bottom-left">
      <template #trigger>
        <div class="fakeButton">+{{ weet.channels.length - 1 }}</div>
      </template>
      <b-dropdown-item v-for="channel of getListOtherChannel"
                       :key="channel.channelID+'keyDropDownChannelView'">
        <ChannelWorkspace class="channelItem" :channel="channel" :delete-action="false"
                          :selectable="true"/>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Weet} from '@/store/weet/weetModel';
import SharePanel from '@/components/share/SharePanel.vue';
import ButtonUsers from '@/components/actionButton/ButtonUsers.vue';
import {Channel} from '@/store/channel/channelModel';
import ChannelWorkspace from '@/components/channel/ChannelWorkspace.vue';
import WButton from '@/components/wrapper/w-button.vue';

@Component({
  components: {WButton, ChannelWorkspace, SharePanel, ButtonUsers},
})
export default class ChannelWeetView extends Vue {
  @Prop()
  private weet!: Weet;

  get getFirstChannel(): Channel | undefined {
    if (this.weet.channels.length > 0) {
      return this.weet.channels[0];
    } else {
      return undefined;
    }
  }

  get getListOtherChannel(): Channel[] {
    if (this.weet.channels.length > 1) {
      return this.weet.channels.slice(1, this.weet.channels.length);
    } else {
      return [];
    }
  }
}
</script>

<style scoped lang="scss">

.channelsContainer {
  display: flex;
  align-items: center;
  width: 100%;

  .firstChannelContainer {
    display: flex;

    .firstChannel {
      max-width: 245px;
    }
  }

  .plusDropDown {
    margin-left: 4px;

    .fakeButton {
      background: var(--light);
      color: var(--light2);
      font-size: 14px;
      border-radius: 8px;
      padding-left: 8px;
      padding-right: 8px;
      cursor: pointer;

      &:hover {
        color: var(--dark);
      }
    }
  }

}
</style>
